module.exports = __webpack_public_path__ + "img/item5.98016217.jpg";